<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <a-table
        :columns="columns"
        :data-source="categories"
        :row-key="'id'"
        :loading="loading"
        :pagination="paginationConfig"
        :scroll="{ x: 860 }"
        class="text-nowrap align-middle income-category-table"
      >
        <template #emptyText>
          <div class="py-4 text-center text-muted">{{ t("income_category_page.no_income_categories_found") }}</div>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column && column.key === 'name'">
            <div class="d-flex flex-column">
              <span class="fw-semibold text-dark">{{ record.name || t("income_category_page.not_available_short") }}</span>
              <span class="text-muted small">{{ t("income_category_page.category_label") }}</span>
            </div>
          </template>
          <template v-else-if="column && column.key === 'code'">
            <span class="code-pill">{{ record.code || t("income_category_page.not_available_short") }}</span>
          </template>
          <template v-else-if="column && column.key === 'description'">
            <span class="description-cell">{{ record.description || t("income_category_page.no_description") }}</span>
          </template>
          <template v-else-if="column && column.key === 'actions'">
            <div class="d-flex justify-content-center gap-2 table-actions">
              <button class="btn p-0 border-0 action-icon-btn" :title="t('income_category_page.edit')" data-bs-toggle="modal" data-bs-target="#incomeCategoryModal" @click="$emit('edit-category', record)">
                <img src="../../../assets/img/icons/edit.svg" :alt="t('income_category_page.edit')" style="width: 14px" />
              </button>
              <button class="btn p-0 border-0 action-icon-btn" :title="t('income_category_page.delete')" @click="$emit('delete-category', record)">
                <img src="../../../assets/img/icons/close.svg" :alt="t('income_category_page.delete')" style="width: 14px" />
              </button>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import type { IncomeCategory } from "@/services/income";

export default defineComponent({
  name: "IncomeCategory",
  props: {
    categories: { type: Array as () => IncomeCategory[], default: () => [] },
    loading: { type: Boolean, default: false },
  },
  emits: ["edit-category", "delete-category"],
  setup() {
    const { t } = useI18n();
    const columns = computed(() => [
      { title: t("income_category_page.category_name"), key: "name", align: "left" as const, width: 240 },
      { title: t("income_category_page.code"), key: "code", align: "center" as const, width: 160 },
      { title: t("income_category_page.description"), key: "description", align: "left" as const, width: 320 },
      { title: t("income_category_page.action"), key: "actions", align: "center" as const, width: 120 },
    ]);

    const paginationConfig = computed(() => ({
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "30", "50", "100"],
      defaultPageSize: 10,
      locale: { items_per_page: t("income_category_page.items_per_page") },
    }));

    return { columns, paginationConfig, t };
  },
});
</script>

<style scoped>
.income-category-table :deep(.ant-table-cell) { vertical-align: middle; }
.income-category-table :deep(.ant-table-thead > tr > th) { white-space: nowrap; }
.code-pill {
  display: inline-flex; align-items: center; justify-content: center; min-width: 94px; padding: 7px 12px;
  border-radius: 999px; background: #f1f5ff; color: #4d5ee1; font-size: 12px; font-weight: 700;
}
.description-cell { display: inline-block; max-width: 100%; white-space: normal; color: #667085; }
.table-actions { min-width: 56px; }
.action-icon-btn { width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; }
</style>
